/**
 * Created by mateo on 6/29/17.
 */
import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'momentFormat' , standalone: false})

export class MomentFormatPipe implements PipeTransform {
    transform(mDate, format) {
        return moment(mDate).format(format);
    }
}